var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClose32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.293 8.293a1 1 0 0 1 1.414 0L16 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414L17.414 16l6.293 6.293a1 1 0 0 1-1.414 1.414L16 17.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L14.586 16 8.293 9.707a1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
})));
export default SvgIcClose32;